<template>
	<div class="imageSearch container">

			<div class="imageSearch__colmun">
				<div class="imageSearch__col1">
					<h2 class="imageSearch__heading">イメージ検索</h2>
				</div>
				<div class="imageSearch__col2">
					<form v-on:submit.prevent="imageSearchSubmit">
						<ul class="imageSearch__items">
							<li v-for="item in images">
								<button v-on:click.prevent="imageSearchSubmit" v-bind:name="item.id" value="1"><img v-bind:src="'/static/images/imageSearchBlock/' + item.btnimage" v-bind:alt="item.name"></button>
							</li>
						</div>
					</form>
				</div>
			</div>

	</div>
</template>
<script>
import { searchConditions, SCStr, imageSearch, checkboxImageSearch } from '../vuex/actions';
import { getSearchWords, getSearchConditions, getImage, getCheckedImage } from '../vuex/getters';
module.exports = {
	vuex: {
		getters: {
			w: getSearchWords,
			c: getSearchConditions,
			// checked: getChecked,
			checkedImage: getCheckedImage,
			// sliderValue: getSliderValue,
			// prefecturesList: getPrefecturesList,
			// district: getDistrict,
			// areaCode: getAreaCode,
			// situation: getSituation,
			// facility: getFacility,
			// service: getService,
			images: getImage
		},
		actions: {
			// updateSearchWords: searchWords,
			updateSearchConditions: searchConditions,
			// updateRadio: radio,
			// updateCheckbox: checkbox,
			// setAreaCode: areacode,
			setSCStr: SCStr,
			updateImage: imageSearch,
			updateCheckboxIS: checkboxImageSearch
		}
	},
	methods: {
		debug: function(){
			console.log(this.checked);
		},
		imageSearchSubmit: function(e){
			// actions
			this.updateImage(e);

			var queryArray = [];
			var conditionArr = [];

			// イメージ検索
			var ciObj = this.checkedImage;
			var checkedImageStrArr = [];
			checkedImageStrArr = checkedImageStrArr.concat(this.images);

			for (var ciProp in ciObj){
				if (ciObj[ciProp] !== 0){
					// query
					queryArray.push(ciProp + ':' + ciObj[ciProp]);

					// condition
					for (var ciItem in checkedImageStrArr){
						if (ciProp === checkedImageStrArr[ciItem].id){
							conditionArr.push(checkedImageStrArr[ciItem].name);
						}
					}
				}
			}

			this.updateSearchConditions(queryArray.join('/'));

			var keywords = this.w;
			var conditions = this.c;

			conditionArr.unshift(keywords);
			this.setSCStr(conditionArr.join('&emsp;'));

			// submit
			this.$route.router.go({
				name: 'searchresult',
				query: {
					w: keywords,
					c: conditions
				}
			});
		}
	},
	mixins: [
		// require('../mixins/searchSubmit.js')
	]
};
</script>



// WEBPACK FOOTER //
// image_search.vue?2b7c8765